var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c(
        "div",
        [
          _c("div", { staticClass: "lead-timeline-info" }, [
            _c("div", { staticClass: "timeline-avtor" }, [
              _c(
                "div",
                { staticClass: "lead-timeline-action timeline-comment" },
                [_vm._v("Commented")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "lead-timeline-employee" }, [
                _vm._v("by " + _vm._s(_vm.item.user_name) + ":"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "timline-date" }, [
              _vm._v(_vm._s(_vm.item["date&time"])),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.items, function (comment) {
            return _c("div", {
              staticClass: "timeline__item_text",
              domProps: { innerHTML: _vm._s(comment.content) },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }